import { render, staticRenderFns } from "./_Home.vue?vue&type=template&id=54ecbe42"
import script from "./_Home.vue?vue&type=script&lang=js"
export * from "./_Home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports